import * as React from 'react';

import * as style from './style.css';

export interface IActionButtonsProps {
  selections: React.ReactElement;
  newReview: React.ReactElement;
}

export const ActionButtons: React.FC<IActionButtonsProps> = ({ selections, newReview }) => {
  return (
    <div data-testid="ReviewsButtons" className={style['buttons']}>
      <div className={style['button']}>{selections}</div>

      <div className={style['button']}>{newReview}</div>
    </div>
  );
};
